module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image19a.6fe66246.jpg";